
import React, { memo, useRef } from 'react';
import { Box } from '@mui/material';

import {
  CreateScheduleMenu,
  DayOffSection,
  EmptyStateBlock,
  HolidaysSection,
  ScheduleMenuActionType,
  SectionDelimiter,
  WorkingTimeSection,
} from './components';

export interface PeriodDates {
  from: string; //2023-10-21T00:00:00.000Z
  to: string; //2023-10-21T00:00:00.000Z
}

interface Time {
  hours: number;
  minutes: number;
}

export interface PeriodTimes {
  from: Time;
  to: Time;
}

export type WeekDay =
  | '0' // Sunday
  | '1' // Monday
  | '2' // Tuesday
  | '3' // Wendensday
  | '4' // Thursday
  | '5' // Friday
  | '6'; // Saturday

export interface WorkingTime {
  period: PeriodDates;
  daysPeriods: {
    [key in WeekDay as string]: PeriodTimes;
  };
}

export interface DayOff {
  period: PeriodDates;
  reason: string;
}

export interface Holiday {
  date: string; //2023-10-21T00:00:00.000Z
  name: string;
  workHours?: PeriodTimes;
}

interface CalendarSideBarProps {
  workingTimes?: Array<WorkingTime>;
  onWorkingTimesChange?: (newWorkingTimes: any) => void;

  daysOff?: Array<DayOff>;
  onDaysOffChange?: (newDaysOff: any) => void;

  holidays?: Array<Holiday>;
  onHolidaysChange?: (newHolidays: any) => void;

  lastUpdated?: string;
  period?: any;

  periodId?: any;
  onChangePeriodId?: (newId: any) => void;
}

const CalendarSideBar = ({
  workingTimes,
  periodId,
  onChangePeriodId,
  onWorkingTimesChange,
  daysOff,
  onDaysOffChange,
  holidays,
  onHolidaysChange,
  lastUpdated,
  period,
}: CalendarSideBarProps) => {
  const scheduleMenuRef = useRef();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minWidth: '270px',
        maxWidth: '270px',
        borderRight: '1px solid #D6D6DB',
        padding: '40px 24px 0px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CreateScheduleMenu
          periodId={periodId}
          onChangePeriodId={onChangePeriodId}
          ref={scheduleMenuRef}
          workingTimes={workingTimes}
          onWorkingTimesChange={onWorkingTimesChange}
          daysOff={daysOff}
          onDaysOffChange={onDaysOffChange}
          holidays={holidays}
          onHolidaysChange={onHolidaysChange}
          period={period}
        />
        {workingTimes?.length || holidays?.length || daysOff?.length ? (
          <>
            <WorkingTimeSection
              onClick={() => {
                // @ts-ignore
                scheduleMenuRef?.current?.showModal(
                  ScheduleMenuActionType.WorkTime,
                  0
                );
              }}
              workingTimes={workingTimes}
            />
            <SectionDelimiter />
            <HolidaysSection
              onClick={(typeOfHolidayId) => {
                // @ts-ignore
                scheduleMenuRef?.current?.showModal(
                  ScheduleMenuActionType.Holidays,
                  typeOfHolidayId
                );
              }}
              holidays={holidays}
              lastUpdated={lastUpdated}
            />
            <SectionDelimiter />
            <DayOffSection
              onClick={(reasonKey) => {
                // @ts-ignore
                scheduleMenuRef?.current?.showModal(
                  ScheduleMenuActionType.DaysOff,
                  reasonKey
                );
              }}
              daysOff={daysOff}
            />
          </>
        ) : (
          <EmptyStateBlock
            img="/images/empty-page-states/working-time-sidebar-empty.png"
            text='This is still empty, you need to create rules that will determine the time frame of the studio.'
          />
        )}
      </Box>
    </Box>
  );
};

export {CalendarSideBar}
